export default __webpack_public_path__ + "static/media/account.71018170.svg";